import { api_client } from '@src/bootstrap/index';
import { USER } from '@src/services/user';

export const getUnsupportedCountrys = async () => {
    const { retrieveUnsupportedCountries: data } = (await api_client.query({
        query: USER.RETTRIEVE_UNSUPPORTED_COUNTRYS,
    })) as { retrieveUnsupportedCountries: string[] };
    return data;
};

export const updateTelegramId = async (telegram_id: string) => {
    const { setTelegramId } = await api_client.mutate<{
        setTelegramId: number;
    }>({
        mutation: USER.SET_TELEGRAM_ID,
        variables: { telegram_id },
    });

    return setTelegramId;
};
